import ImageClass from "@lss/common/src/shell/Image";
import { mc } from "@lss/common/game/characters/MC";
import { images } from "@lss/common/game/story/images";
import { joe } from "../characters/Joe";
import { vanessa } from "../characters/Vanessa";
import { empty } from "../characters/empty";
import Question from "../../src/shell/Questions";
import { ann } from "../characters/Ann";
import { jump } from "../../src/shell/jump";
import Game from "../../src/shell/Game";
import { AfterTOD } from "./V3";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { doSmsSound } from "../helpers/helpers";

export const TODManager = async () => {
    ImageClass.setImage(images.v2_5.TODSpinning, { duration: 1 });
    joe.talk(`Spinning!`);
    if (empty.properties.todProgress === 0) {
        return jump(TODVanAnn1, "TODVanAnn1");

    } else if (empty.properties.todProgress === 1) {

        return jump(TODSelfJoe1, "TODSelfJoe1");
    } else if (empty.properties.todProgress === 2) {

        return jump(TODAnnVanessa1, "TODAnnVanessa1");
    } else if (empty.properties.todProgress === 3) {

        return jump(TODAnnJoe1, "TODAnnJoe1");
    } else if (empty.properties.todProgress === 4) {

        return jump(TODMcVanessa1, "TODMcVanessa1");

    } else if (empty.properties.todProgress === 5) {
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber && mc.properties.annStatus === "hate") {

            return jump(TODAnn4, "TODAnn4");
        }
        return jump(TODAnn2, "TODAnn2");
    } else if (empty.properties.todProgress === 6) {

        return jump(TODMcJoe1, "TODMcJoe1");
    }


    return jump(TODEnd, "TODEnd");

};
export const TODVanAnn1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODVanAnn1);
    joe.talk(`Vanessa asks Ann.`);
    vanessa.talk(`I'm so LUCKY!`);
    ann.talk(`Just my luck. I knew I'd end up going first.`);
    vanessa.talk(`It's always the ones that are scared. Haha.`);
    ann.talk(`I am not scared...`);
    vanessa.talk(`Prove it!\nAnn, truth or dare?`);
    ann.talk(`I'll pick truth.`);
    vanessa.talk(`I knew you'd choose that.`);
    ann.talk(`I don't want to be the first one who chooses dare...`);
    vanessa.talk(`It better be your last truth of the night!`);
    vanessa.talk(`Ok, so let's see.\nWhat can I ask you?`);
    vanessa.talk(`Oh, I know!`);
    vanessa.talk(`Do you currently have a crush on anyone?`);
    ann.talk(`Yes.`);
    vanessa.talk(`WHO? TELL ME!`);
    ann.talk(`That's not how it works! I told the truth, if I tell you who that is, it will make it a double truth.\nYou'll have to wait for the next time.`);
    vanessa.talk(`You better answer that question now or I'll start asking you really hard questions.\nIf you know what I mean.`);
    vanessa.talk(`Tell me! Who is it?`);
    ann.talk(`Geez...`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber && mc.properties.annStatus === "hate") {
        await ann.set((properties) => {
            properties.likedDuringTOD = "chris";
        });
        ann.talk(`It's Chris.`);
        vanessa.talk(`Chris? Who the fuck is Chris?`);
        mc.talk(`That's the bartender who asked for her number when we went out.`);
        vanessa.talk(`OH shit!\nI heard about him.`);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtVan);
        joe.talk(`When?`);
        vanessa.talk(`When you left for the gym this morning me and ${mc.name} had a small chat.`);
        vanessa.talk(`Ann! DETAILS NOW!`);
        ImageClass.setImage(images.v2_5.TODVanAnn1);
        ann.talk(`That's all I can say for now.`);
    } else if (mc.properties.annStatus === "gf") {
        await ann.set((properties) => {
            properties.likedDuringTOD = "mc";
        });
        ann.talk(`It's ${mc.name}...`);
        vanessa.talk(`Finally! Someone that you like who isn't from a fiction book.`);
        ann.talk(`I've had a crush before...`);
        vanessa.talk(`The only crush you've had is the Candy Crush app on your phone.`);
        ann.talk(`Very funny...`);
    } else {
        await ann.set((properties) => {
            properties.likedDuringTOD = "joe";
        });
        ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtVan);
        ann.talk(`It's Joe...`);
        vanessa.talk(`I KNEW IT YOU SLUT!`);
        ann.talk(`I'm sorry.`);
        vanessa.talk(`That's ok, I'm not mad, of course you'd have a crush on my stud.`);
    }


    ann.talk(`Ok, enough about me, that was embarrassing enough, let's just keep going.`);
    await empty.set((properties) => {
        properties.todProgress = 1;
    });
    return jump(TODManager, "TODManager");
};
export const TODSelfJoe1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODJoeSelf1);
    joe.talk(`Looks like I'm asking ${mc.name}.`);
    // mc.think(`I wonder if he did that on purpose...`);

    await joe.setQuestion(new Question({ text: `${mc.name}, truth or dare?`, key: `v2_5TODJoeAskingMCTruthOrDare` })
        .option({ title: `Truth`, key: `truth` })
        .option({ title: `Dare`, key: `dare` }));


    if (Question.globalAnswers.v2_5TODJoeAskingMCTruthOrDare === "truth") {
        mc.talk(`Truth.`);
        joe.talk(`Alright.`);
        ann.talk(`You see, Vanessa, he chose truth as well.`);
        vanessa.talk(`What can I say, you guys must be really fun at parties.`);
        joe.talk(`Quiet!`);
        joe.talk(`Ok, so my question to you.`);
        joe.talk(`Let's say you have a huge crush on someone, and she invites you over to her empty home.`);
        joe.talk(`While going there you get a call from me, saying my car broke down and I need you to come pick me up.`);

        // await joe.setQuestion(new Question({ text: `Are you jealous of my new life style?`, key: `v2_5JealousLifestyle` })
        //     .option({ title: `Yes`, key: true })
        //     .option({ title: `No`, key: false }));
        await joe.setQuestion(new Question({ text: `Who would you choose?`, key: `v2_5WhoWouldYouChoose` })
            .option({ title: `I'd choose you`, key: "joe" })
            .option({ title: `I'd choose my crush`, key: "crush" }));


        // if (Question.globalAnswers.v2_5JealousLifestyle) {
        //     mc.talk(`I am. Yes.`);
        // } else {
        //     mc.talk(`No, I'm not.`);
        // }
        if (Question.globalAnswers.v2_5WhoWouldYouChoose === "joe") {
            mc.talk(`I'd choose you.`);
            joe.talk(`Bro! I know it.`);
            vanessa.talk(`Pft, yeah right.`);
            joe.talk(`Why do you find that so hard to believe?`);
            vanessa.talk(`Isn't it obvious?`);
            joe.talk(`...`);

        } else {
            mc.talk(`I'd choose my crush.`);
            joe.talk(`Bro...`);
            vanessa.talk(`What did you expect?`);
            joe.talk(`I honestly thought you'd choose me.`);
            ImageClass.setImage(images.v2_5.TOD8);
            mc.talk(`Sorry man... If that was someone I was really into you would've taken a taxi.`);
            joe.talk(`Damn... Not wrong.`);

            vanessa.talk(`Yeah Joe! Don't cock block your best friend!`);

        }
        // vanessa.talk(`Are you serious? That's your question?`);
        // vanessa.talk(`He would have answered it even outside the game.`);
        // joe.talk(`I have my reasons.`);
        // vanessa.talk(`Whatever!`);

    } else {

        mc.talk(`I choose dare.`);
        await joe.setQuestion(new Question({ text: `I dare you to say.\nWho would you fuck? Ann or Vanessa?`, key: `v2_5WhoWouldYouFuck` })
            .option({ title: `Ann`, key: `ann` })
            .option({ title: `Vanessa`, key: `vanessa` }));


        if (Question.globalAnswers.v2_5WhoWouldYouFuck === "ann") {
            mc.talk(`Ann.`);
            ann.talk(`Oh...`);
            if (mc.properties.annStatus === "gf") {
                vanessa.talk(`You both like each other, what's stopping you?`);
                vanessa.talk(`Go to ${mc.name}'s room and have at it! Haha.`);
                ann.talk(`Vanessa? Are you jealous?`);
                vanessa.talk(`I'm not but it's a surprise.`);
                vanessa.talk(`People usually pick me.`);
            } else {
                if (mc.properties.annStatus === "hate") {

                    ann.talk(`Yeah right...`);
                }
                vanessa.talk(`Looks like someone really likes Ann, people usually pick me.`);
                if (mc.properties.annStatus === "hate") {
                    ann.talk(`He doesn't.`);
                    vanessa.talk(`Ann, is there something you wanna tell us?`);
                    ann.talk(`No.`);
                }
            }


            joe.talk(`Wait, you said people, what kind of people?`);
            vanessa.talk(`The people I used to play truth and dare with.`);
            joe.talk(`Do you play this game without me?`);
            vanessa.talk(`I used to, yeah.`);
            joe.talk(`Interesting.`);
            vanessa.talk(`Why are you so surprised?`);
            joe.talk(`I'm not.\nLet's continue.`);
        } else {
            mc.talk(`Vanessa.`);
            vanessa.talk(`Great! Let's go to your room to make it happen! Haha.`);
            vanessa.talk(`Ann, don't worry I'm sure you were his second choice.`);
            ann.talk(`Out of two... Yes, that makes sense.`);
            ann.talk(`Besides, I don't really care.\nLet's just continue.`);
            mc.think(`I hope I didn't offend her.`);
        }


    }
    await empty.set((properties) => {
        properties.todProgress = 2;
    });
    return jump(TODManager, "TODManager");
};
export const TODAnnVanessa1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnVan1);
    joe.talk(`Ann asks Vanessa!`);
    ann.talk(`Finally!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ann.talk(`Vanessa, truth or dare?`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`I usually pick dare, but because you picked truth, I'm gonna pick truth also.`);
    ann.talk(`Mmm... Ok.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
    ann.talk(`Do you remember when we were sixteen, and there was that boy I really liked?`);
    vanessa.talk(`Yes, Edward, what about him?`);
    ann.talk(`After I told you about him he started avoiding me, you always denied saying something to him.`);
    ann.talk(`Tell me the truth, did you say something to scare him away?`);
    vanessa.talk(`I didn't say anything to him.`);
    ann.talk(`I don't believe it.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtVan);
    vanessa.talk(`But I happened to give him a hand job...`);
    ann.talk(`WHAT?`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
    vanessa.talk(`It wasn't on purpose!`);
    ann.talk(`How can that happen by mistake?`);
    vanessa.talk(`I'll explain.`);
    ann.talk(`Please do.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtVan);
    vanessa.talk(`Ok, so I knew you liked him right?`);
    vanessa.talk(`I wanted to make sure he wouldn't hurt you.`);
    vanessa.talk(`So I met up with him just to see what he was like.`);
    vanessa.talk(`One thing led to another.\nAnd I gave him a hand job.`);
    vanessa.talk(`He wasn't as innocent as you think, he started flirting with me right away.`);
    ann.talk(`I find that hard to believe.\nHe never flirted with me, he was just being nice.`);
    vanessa.talk(`Men find me easy to flirt with. What can I say?`);
    ann.talk(`Ok...`);
    vanessa.talk(`Don't tell me you are still mad about that.`);
    ann.talk(`I'm not, I just knew you were lying all this time.`);
    vanessa.talk(`I didn't lie, you just didn't ask the right questions.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
    joe.talk(`Ok ladies, don't fight.`);
    mc.think(`Joey doesn't seem to care...`);
    joe.talk(`Let's continue.`);
    await empty.set((properties) => {
        properties.todProgress = 3;
    });
    return jump(TODManager, "TODManager");
};
export const TODAnnJoe1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnJoe1);
    joe.talk(`I'm asking Ann!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
    ann.talk(`It's not even pointing at me!`);
    joe.talk(`It's close enough, we are only four.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`Joe's right.`);
    ann.talk(`Fine...`);
    ann.talk(`Ask away.`);


    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtJoe);
    vanessa.talk(`You should think of a truth to ask her.`);
    ann.talk(`No. I'll go with dare this time.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`Oh! Look who showed up for the game!`);
    mc.think(`I wonder what he will ask her.`);
    if (Question.globalAnswers.v25JoeTODAgree) {

        mc.think(`I did agree to let him fool around with her.`);
        await ann.set((properties) => {
            properties.kissedDuringTOD.push("joe");
        });
        joe.talk(`I dare you to kiss me!`);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
        if (ann.properties.likedDuringTOD === "joe") {
            ann.talk(`It was a mistake saying that I like you...`);
            joe.talk(`A dare is a dare.`);
        }
        ann.talk(`But... Vanessa is sitting right here.`);
        joe.talk(`She ain't complaining.`);
        if (mc.properties.annStatus === "gf") {

            ann.talk(`${mc.name}?`);
        }
        ann.talk(`Fine. I'll do it as a revenge for Edward.`);

        ImageClass.setImage(images.v2_5.TODAnnJoeKiss);
        mc.think(`I thought she was going to chicken out.`);
        mc.think(`I wonder what's going on in Vanessa's mind right now.`);
        mc.think(`Or in Joe's mind, what is he trying to achieve?`);
        ImageClass.setImage(images.v2_5.TODAnnJoeKissZoom);
        mc.think(`Is he trying to make Vanessa jealous or did he just want to make out with Ann?`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {
            mc.think(`She's kinda getting what she deserves after sucking the bartender's dick...`);
            mc.think(`I wonder if he knows about that and he's trying to make her jealous.`);
        }
        vanessa.talk(`Ok that's enough.`);
        ImageClass.setImage(images.v2_5.TODAnnJoe1);
        joe.talk(`Thank you Ann, that was great.`);
        await empty.set((properties) => {
            properties.todProgress = 4;
        });
        return jump(TODManager, "TODManager");
    } else {

        if (mc.properties.annStatus === "hate") {

            return jump(TODAnnJoe1KissVanessa, "TODAnnJoe1KissVanessa");
        }
    }

    await ann.set((properties) => {
        properties.kissedDuringTOD.push("mc");
    });
    joe.talk(`I dare you to kiss ${mc.name}.`);
    ann.talk(`I knew it, that's the only dare you guys can think of.`);
    joe.talk(`It's just a kiss.`);
    ann.talk(`Fine.`);
    ImageClass.setImage(images.v2_5.TODAnnSelfKiss1);
    if (mc.properties.annStatus === "natural") {
        ann.talk(`I barely know you, but I hope you don't think I do this all the time.`, { method: "Whispering" });

    }

    if (mc.properties.annStatus === "gf") {

        if (Question.globalAnswers.v2KissedAnn) {

            ImageClass.setImage(images.v2_5.TODAnnSelfKiss1Smile);
            ann.talk(`It's not like we didn't do it a few hours ago, hehe.`, { method: "Whispering" });
        } else {

            ann.talk(`You know, I've never kissed in front of people.`, { method: "Whispering" });
        }


    }

    ImageClass.setImage(images.v2_5.TODAnnSelfKiss2);
    vanessa.talk(`Look at them go!`);
    vanessa.talk(`Come on, I wanna see more tongue!`);
    if (mc.properties.annStatus === "gf") {

        ImageClass.setImage(images.v2_5.TODAnnSelfKiss1Smile);
    } else {

        ImageClass.setImage(images.v2_5.TODAnnSelfKiss1);
    }
    ann.talk(`Ok that's enough, hehe.`);
    ImageClass.setImage(images.v2_5.TODAnnJoe1);
    await empty.set((properties) => {
        properties.todProgress = 4;
    });
    return jump(TODManager, "TODManager");
};

export const TODAnnJoe1KissVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnJoe1);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtJoe);
    await ann.set((properties) => {
        properties.kissedDuringTOD.push("vanessa");
    });
    joe.talk(`Kiss Vanessa!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
    ann.talk(`Are you insane?`);
    ann.talk(`She is my best friend, and... a girl...`);
    ann.talk(`I like guys...`);
    vanessa.talk(`Come on Ann, I saw you reading a lesbian romance book once.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ann.talk(`I also read books about dwarves and elves that doesn't make me one.`);
    ImageClass.setImage(images.v2_5.TODAnnVanessaKiss1);
    vanessa.talk(`Oh my God.`);
    vanessa.talk(`Shut up and kiss me.`);
    ImageClass.setImage(images.v2_5.TODAnnVanessaKiss2);
    ann.talk(`Buu.... Mhmmm...`);
    mc.think(`That girl has no limits...`);
    ImageClass.setImage(images.v2_5.TODAnnVanessaKiss1);
    ann.talk(`Ok that's enough.`);
    await empty.set((properties) => {
        properties.todProgress = 4;
    });
    return jump(TODManager, "TODManager");
};

export const TODMcVanessa1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODSelfVanessa1);
    joe.talk(`${mc.name} asks Vanessa.`);
    ImageClass.setImage(images.v2_5.TODSelfVanessa2);
    vanessa.talk(`I'll show you guys how to play this game.`);
    vanessa.talk(`${mc.name}, give me an interesting dare!`);
    mc.think(`She asked for it...`);

    await mc.setQuestion(new Question({ text: `I dare you to:`, key: `todMCDareVanessa` })
        .option({ title: `Show me your boobs`, key: `showBoobs` })
        .option({ title: `show me your panties`, key: `showPanties` }));


    if (Question.globalAnswers.todMCDareVanessa === "showBoobs") {
        mc.talk(`Show me your boobs.`);
        ImageClass.setImage(images.v2_5.TODSelfVanessa3);
        vanessa.talk(`Finally! A good dare.`);

        if (Question.globalAnswers.v1JoeBeachQuestionsArr?.includes("sawVanNudes")) {

            mc.think(`I've already told him I saw her picture on his phone, so I bet he won't mind if I see them again.`);
            mc.think(`But this time, in real life.`);
        } else {
            mc.talk(`Joey, are you okay with this?`);
            joe.talk(`I don't mind.`);

        }
        vanessa.talk(`I knew you wanted to see them.`);
        vanessa.talk(`Alright, take a good look.`);
        ImageClass.setImage(images.v2_5.TODSelfVanessa4);
        mc.think(`She didn't take her shirt all the way down but they are still very nice.`);
        vanessa.talk(`You are the only one in this room who hasn't seen my boobs.`);
        joe.talk(`When did Ann see them?`);
        ann.talk(`She likes to walk around naked when she sleeps over...`);
        ImageClass.setImage(images.v2_5.TODSelfVanessa3);
        vanessa.talk(`I hope you got a good look.`);
        ImageClass.setImage({ ...images.v2_5.TODSelfVanessa1, partialsToDisplay: [images.v2_5.TOD8.partials.TODVanessaLookingAtJoe] });
        joe.talk(`He must have, because I had the worst angle.`);
        // ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtJoe);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
        vanessa.talk(`Relax. You see them all the time.`);

    } else {
        mc.talk(`Show me your panties.`);
        ImageClass.setImage(images.v2_5.TODSelfVanessa3);
        vanessa.talk(`Good choice, I put on something special today.`);
        joe.talk(`Is it the pink thong?`);
        vanessa.talk(`Take a good look.`);
        ImageClass.setImage(images.v2_5.TODSelfVanessa5);

        mc.think(`She has no panties on!`);
        joe.talk(`${mc.name}, is it the pink one?\nI can't see.`);
        ann.talk(`I can't see either.`);
        if (Question.globalAnswers.v1WentToTheBarWith === "vanessa" && Question.globalAnswers.v2VanessaClothesRedBlackDress === "removePanties") {

            mc.think(`I wonder if she didn't put on a pair because I told her to remove them earlier.`);
        } else {
            mc.think(`I wonder if she didn't wear any because she knew we were playing true or dare.`);
            mc.think(`On the other hand, she couldn't have known I would dare her to do that.`);
        }
        ImageClass.setImage(images.v2_5.TODSelfVanessa3);
        vanessa.talk(`I hope you enjoyed it.`);
        joe.talk(`He better have, cause I didn't see shit.`);
        vanessa.talk(`Relax. You see them all the time.`);
    }
    await empty.set((properties) => {
        properties.todProgress = 5;
    });
    return jump(TODManager, "TODManager");
};
export const TODAnn4 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODVanAnn1);
    joe.talk(`Third time's the charm!`);
    joe.talk(`Vanessa asks Ann.`);
    ann.talk(`I can't believe it. Me again?`);
    vanessa.talk(`Ann, truth again?`);
    ann.talk(`No.`);
    vanessa.talk(`Great! Because I have the perfect dare for you.`);
    vanessa.talk(`I dare you to send a sexy selfie to Chris.`);
    ann.talk(`Are you insane? I'm not going to do that.`);
    ann.talk(`Besides, I don't have sexy photos of myself on my phone.`);
    vanessa.talk(`Oh my God...`);
    vanessa.talk(`Fine, so take a selfie now.`);
    ann.talk(`No way, not in front of you guys.\nOr ever...`);
    vanessa.talk(`Just take a normal selfie of yourself and it's a deal.`);
    ann.talk(`Mmm... That's so embarrassing, but I'll do it.`);
    ImageClass.setImage(images.v2_5.TODVanAnn2);
    vanessa.talk(`Put on a sexy smile!`);
    ann.talk(`Shhh...`);
    ann.talk(`Omg, I can't believe I'm doing that.`);
    ImageClass.setImage({ ...images.v2_5.TODVanAnn1, partialsToDisplay: [images.v2_5.TOD8.partials.TODAnnLookingAtVanessa, images.v2_5.TOD8.partials.TODVanessaLookingAtAnn] });
    ann.talk(`Done.`);
    vanessa.talk(`Great! haha.`);

    await empty.set((properties) => {
        properties.todProgress = 6;
    });
    return jump(TODManager, "TODManager");
};
export const TODAnn2 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODSelfAnn1);

    joe.talk(`Third time's the charm!`);
    joe.talk(`${mc.name} asks Ann.`);
    ann.talk(`I can't believe it. Me again?`);
    await ann.setQuestion(new Question({ text: `Alright, I'll go with a dare.`, key: `todMcAnnSecondTimeKiss` })
        .option({ title: `Kiss Joey`, key: `joey`, show: Question?.globalAnswers?.v1EnableNTR && !ann?.properties?.kissedDuringTOD.includes('joe') })
        .option({ title: `Kiss me`, key: `mc` })
        .option({ title: `Kiss Vanessa`, key: `vanessa` }));


    if (Question.globalAnswers.todMcAnnSecondTimeKiss === "joey") {
        await ann.set((properties) => {
            properties.kissedDuringTOD.push("joe");
        });
        return jump(TODAnn2KissJoey, "TODAnn2KissJoey");
    } else if (Question.globalAnswers.todMcAnnSecondTimeKiss === "vanessa") {

        await ann.set((properties) => {
            properties.kissedDuringTOD.push("vanessa");
        });
        mc.talk(`Kiss Vanessa!`);
        if (ann.properties.kissedDuringTOD?.includes("joe")) {
            ann.talk(`I already kissed Joe!`);
            ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
            vanessa.talk(`So? I kiss him all of the time.`);
            ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
            ann.talk(`Come on...`);
        }

        vanessa.talk(`You have to.`);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
        ann.talk(`But I like guys...`);
        vanessa.talk(`Ann, I saw you were reading a lesbian romance book once.`);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
        ann.talk(`I also read books about dwarves and elves, that doesn't make me one.`);
        ImageClass.setImage(images.v2_5.TODAnnVanessaKiss1);
        vanessa.talk(`Oh my God.`);
        vanessa.talk(`Shut up and kiss me.`);
        ImageClass.setImage(images.v2_5.TODAnnVanessaKiss2);
        ann.talk(`Buu.... Mhmmm...`);
        mc.think(`That girl has no limits...`);
        ImageClass.setImage(images.v2_5.TODAnnVanessaKiss1);
        ann.talk(`Ok, that's enough.`);

        vanessa.talk(`I know you enjoyed that.`);
        ann.talk(`No comment.`);
    } else {

        if (ann.properties.kissedDuringTOD.includes("mc")) {
            mc.talk(`I dare you to kiss me.`);
            ann.talk(`But I did it already.`);
            vanessa.talk(`So it's going to be easier the second time.`);
            if (mc.properties.annStatus === "gf") {

                ann.talk(`Hehe, I don't mind, I did it already.`);

                ImageClass.setImage(images.v2_5.TODAnnSelfKiss1Smile, { duration: 0.6 });
                ann.talk(`Here I come.`, { method: "Whispering" });
            } else if (mc.properties.annStatus === "natural") {

                ann.talk(`Well, fine I don't mind.`);
                ImageClass.setImage(images.v2_5.TODAnnSelfKiss1);
                ann.talk(`I know I've said it already, but I barely know you and it's going to be our second kiss.`, { method: "Whispering" });
            } else {
                ImageClass.setImage(images.v2_5.TODAnnSelfKiss1Smile);
                ann.talk(`Are you doing it on purpose?`, { method: "Whispering" });
                ann.talk(`I have no idea why you turned me down, and now you're daring me to kiss you, again.`, { method: "Whispering" });
            }
        } else {

            mc.talk(`I dare you to kiss me.`);
            ann.talk(`I knew it, that's the only dare you guys can think of.`);
            joe.talk(`It's just a kiss.`);
            if (mc.properties.annStatus === "natural") {
                ImageClass.setImage(images.v2_5.TODAnnSelfKiss1);
                ann.talk(`Well... Hey.`, { method: "Whispering" });
                ann.talk(`I usually don't do this.`, { method: "Whispering" });
                vanessa.talk(`COME ON ALREADY!`);
            } else if (mc.properties.annStatus === "hate") {
                ImageClass.setImage(images.v2_5.TODAnnSelfKiss1);
                ann.talk(`You have some nerve asking me to kiss you after you turned me down.`, { method: "Whispering" });
                ann.talk(`Let's just get it over with.`, { method: "Whispering" });
            } else {
                ImageClass.setImage(images.v2_5.TODAnnSelfKiss1Smile);
                ann.talk(`I am glad you dared me to do it. Hehe.`, { method: "Whispering" });
                if (ann.properties.kissedDuringTOD.includes("joe")) {

                    ann.talk(`I was scared you were going to ask me to kiss Joe again.`);
                } else if (ann.properties.kissedDuringTOD.includes("vanessa")) {

                    ann.talk(`I was scared you were going to ask me to kiss Vanessa again.`);
                }

            }
        }
        await ann.set((properties) => {
            properties.kissedDuringTOD.push("mc");
        });



        ImageClass.setImage(images.v2_5.TODAnnSelfKiss2, { duration: 0.6 });
        joe.talk(`Come on put some more effort into it!`);
        ImageClass.setImage(images.v2_5.TODAnnSelfKiss2);
        vanessa.talk(`Look at them go!`);
        vanessa.talk(`Come on, I wanna see more tongue!`);
        ImageClass.setImage(images.v2_5.TODSelfAnn1);
        ann.talk(`That's enough.`);

    }


    joe.talk(`Let's keep going.`);

    await empty.set((properties) => {
        properties.todProgress = 6;
    });
    return jump(TODManager, "TODManager");
};

export const TODAnn2KissJoey = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v2_5.TODSelfAnn1, partialsToDisplay: [images.v2_5.TOD8.partials.TODJoeLookingAtAnn] });
    mc.talk(`I dare you to kiss Joey.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
    ann.talk(`Joey?`);
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage({ ...images.v2_5.TODSelfAnn1, partialsToDisplay: [images.v2_5.TOD8.partials.TODJoeLookingAtAnn] });

        ann.talk(`${mc.name}? R...Really? But I thought we...`);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
        ann.talk(`I am so confused.`);
        if (!Question.globalAnswers.v1EnableNTR) {
            mc.think(`She has no idea that I decided to be a good friend and help Joey with his little plan...`);
            mc.think(`I just hope it'll be worth it.`);
        }
    }

    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`Just do it!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ann.talk(`Why am I the only one who has to kiss people?`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
    joe.talk(`Ann, I am waiting.`);
    if (ann.properties.kissedDuringTOD.includes("vanessa")) {
        ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
        ann.talk(`I already kissed Vanessa!`);
        ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
        vanessa.talk(`That doesn't count, I kissed you!`);
        ann.talk(`Not my problem! It was my dare and it's completed now.`);
    }

    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`We aren't kids anymore Ann.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ann.talk(`But...`);
    ann.talk(`Fine!`);
    ImageClass.setImage(images.v2_5.TODAnnJoeKiss);
    vanessa.talk(`How cute she is really trying!`);
    mc.think(`How come isn't Vanessa jealous?`);
    mc.think(`She even encouraged it.`);
    ImageClass.setImage(images.v2_5.TODAnnJoeKissZoom);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {

        mc.think(`Maybe she is too busy thinking on that bartender's dick to care about a stupid kiss.`);
    }
    if (mc.properties.annStatus === "gf") {

        mc.think(`I wonder what's going on in her head right now.`);
        mc.think(`Except from Joey's tongue...`);
    }
    ImageClass.setImage(images.v2_5.TODSelfAnn1);

    ImageClass.setImage({ ...images.v2_5.TODSelfAnn1, partialsToDisplay: [images.v2_5.TOD8.partials.TODJoeLookingAtVan, images.v2_5.TOD8.partials.TODAnnLookingAtVanessa, images.v2_5.TOD8.partials.TODVanessaLookingAtAnn] });
    vanessa.talk(`Ok that's enough.`);
    vanessa.talk(`To be honest. It was longer than I excepted.`);
    joe.talk(`Let's keep going.`);

    await empty.set((properties) => {
        properties.todProgress = 6;
    });
    return jump(TODManager, "TODManager");
};
export const TODMcJoe1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODSelfJoe1);

    joe.talk(`${mc.name} asks me.`);
    mc.talk(`Alright, Joey, truth or dare?`);
    joe.talk(`Dare.`);
    await mc.setQuestion(new Question({ text: `I dare you to spend five minutes in my room with...`, key: `todGoRoomWith` })
        .option({ title: `Vanessa`, key: `vanessa` })
        .option({ title: `Ann`, key: `ann` }));


    if (Question.globalAnswers.todGoRoomWith === "vanessa") {
        mc.talk(`I dare you to spend five minutes in my room with Vanessa.`);
        joe.talk(`Of course! No problem.`);
        vanessa.talk(`Easiest dare of your life babe, haha.`);
        joe.talk(`Be right back!`);
        return jump(TODAnnAlone1, "TODAnnAlone1");
    }
    mc.talk(`I dare you to spend five minutes in my room with Ann.`);
    ann.talk(`What?`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
    joe.talk(`Don't be worried.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtJoe);
    ann.talk(`I don't know you...`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    joe.talk(`We aren't going to do anything.\nMy girlfriend is right here.`);
    ann.talk(`Fine, but only five minutes.`);
    joe.talk(`Be right back!`);
    return jump(TODVanessaAlone1, "TODVanessaAlone1");
};

export const TODAnnAlone1 = async (): Promise<any> => {
    if (mc.properties.annStatus === "hate") {

        return jump(TODAnnAlone1_Status1, "TODAnnAlone1_Status1");
    }

    if (mc.properties.annStatus === "natural") {
        ImageClass.setImage(images.v2_5.TODAnnAlone1);
        await mc.setQuestion(new Question({ text: `She is just sitting here...`, options: { think: true }, key: `todAnnMCAloneLivingRoom` })
            .option({ title: `Make small talk`, key: `smallTalk` })
            .option({ title: `Stay silent`, key: `silent` })
            .option({ title: `Talk about the kiss`, key: `talkAboutKiss`, show: ann.properties.kissedDuringTOD.includes("mc") }));


        if (Question.globalAnswers.todAnnMCAloneLivingRoom === "smallTalk") {
            if (mc.properties.metAnn) {
                mc.talk(`So... I haven't seen you since the library.`);
                ImageClass.setImage(images.v2_5.TODAnnAlone1Smile);
                ann.talk(`Yeah, we've talked about that, you went with Vanessa to plan out Joe's birthday.`);
                mc.talk(`Right.`);
                mc.talk(`How are your studies going?`);
                ann.talk(`There are going fine. I feel like I'm on the right track.`);
                mc.talk(`That's great.`);
                ann.talk(`Yeah...`);

            } else {
                mc.talk(`So, how are you?`);
                ann.talk(`I'm fine, and you?`);
                mc.talk(`Doing great.`);
                mc.talk(`What do you do in life?`);
                ImageClass.setImage(images.v2_5.TODAnnAlone1Smile);
                ann.talk(`I'm studying for college.`);
                ann.talk(`I want to get accepted into a good one.`);
                ann.talk(`What about you?`);
                mc.talk(`I'm still figuring it out.`);
                ann.talk(`Good luck with that, hehe.`);

            }

        } else if (Question.globalAnswers.todAnnMCAloneLivingRoom === "silent") {
            mc.think(`I'll just wait for them to come back.`);
        } else {
            mc.talk(`The kiss was nice.`);
            ImageClass.setImage(images.v2_5.TODAnnAlone1Smile);
            ann.talk(`Yes it was, hehe.`);
            ann.talk(`I usually avoid playing these types of games.`);
            mc.talk(`Why?`);
            ann.talk(`It makes me feel cheap, because that's the type of dare girls usually get.`);
            mc.talk(`There is nothing wrong with kissing.`);
            ann.talk(`Of course there isn't, but it needs to come from the girl, not as a dare.`);
            mc.talk(`Maybe.\nI can't say that I totally agree.`);
        }

        return jump(TODAnnAlone1_Continue_Back, "TODAnnAlone1_Continue_Back");
    }



    return jump(TODAnnAlone1_Continue, "TODAnnAlone1_Continue");
};


export const TODAnnAlone1_Status1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone1);
    mc.think(`She doesn't look pleased.`);
    mc.think(`I get it, a few hours ago I invited her to come over and kinda told her that I'm not into her.`);
    mc.think(`So I can understand her mood.`);
    mc.think(`Still, she chose to come over right now.`);

    ann.talk(`Tonight is really weird.`);
    mc.talk(`How so?`);
    ann.talk(`I don't get you.`);
    ann.talk(`Today, when I came over, you said that you don't like me.`);
    if (ann.properties.kissedDuringTOD.includes("mc")) {
        ann.talk(`But now you dare me to kiss you?`);
    } else {
        ann.talk(`And now you sent Joe and Vanessa away to be alone with me?`);
    }

    return jump(TODAnnAlone1_Status2_Question, "TODAnnAlone1_Status2_Question");

};

export const TODAnnAlone1_Status2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone1);

    await ann.setQuestion(new Question({ text: `What's going on in your head?`, key: `todAnnHateLivingRoomConv` })
        .option({ title: `Just wanna have some fun`, key: `haveFun` })
        .option({ title: `I am sorry`, key: `sorry` }));


    if (Question.globalAnswers.todAnnHateLivingRoomConv === "haveFun") {
        mc.talk(`What's wrong with having some fun?`);
        ann.talk(`I don't mind that, but not at my expense...`);
    } else {
        mc.talk(`I am sorry for today.`);
        ann.talk(`I can forgive you, but I need some time.`);
        mc.talk(`I understand that.`);
    }

    return jump(TODAnnAlone1_Status3, "TODAnnAlone1_Status3");
};

export const TODAnnAlone1_Status3 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone1);
    ann.talk(`Let's just wait for them to come back.`);
    if (ann.properties.likedDuringTOD === "chris") {
        doSmsSound();
        ImageClass.setImage(images.v2_5.TODAnnAlone2);
        ann.talk(`Hehe.`);
        mc.talk(`What is it?`);
        ann.talk(`I got a text.`);
        ann.talk(`From Chris.`);
        ann.talk(`"I'm really glad to hear from you, your smile is really pretty.\nWe should meet soon..."`);
        ann.talk(`"...You have a really pretty smile.\nCall me sometimes. XOXO"`);

        return jump(TODAnnAlone1_Status1_Question_Pic, "TODAnnAlone1_Status1_Question_Pic");
    }
    return jump(TODAnnAlone1_Continue, "TODAnnAlone1_Continue");
};

export const TODAnnAlone1_Status1_Question_Pic = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone1);
    await ann.setQuestion(new Question({ text: `There is a picture attached.\nDo you want to see it?`, key: `todAnnLivingRoomSeenChrisPic` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.todAnnLivingRoomSeenChrisPic) {
        mc.talk(`Yes, show me.`);
        ImageClass.setImage(images.v2_5.TODAnnAlone4);
        mc.think(`Of course he would send a picture like that.`);
        ImageClass.setImage(images.v2_5.TODAnnAlone4Zoom);
        mc.think(`That's why her mood shifted.`);
    } else {
        mc.talk(`No.`);
        ann.talk(`Ok, hehe.`);
        mc.think(`Wonder why she suddenly started smiling.`);
    }

    return jump(TODAnnAlone1_Continue, "TODAnnAlone1_Continue");
};

export const TODAnnAlone1_Continue = async (): Promise<any> => {
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v2_5.TODAnnAlone3, { transition: true });
        ann.talk(`I'm glad you chose to stay here with me! Hehe.`);
        mc.talk(`Of course!`);
        ann.talk(`Can I ask you something?`);
        mc.talk(`Sure.`);
        if (ann.properties.kissedDuringTOD.includes("joe") && ann.properties.kissedDuringTOD.includes("mc") && ann.properties.kissedDuringTOD.includes("vanessa")) {

            ann.talk(`So... Apparently, I kissed everyone in this room.`);
        }
        if (ann.properties.kissedDuringTOD.includes("joe") && Question.globalAnswers.todMcAnnSecondTimeKiss !== "joey") {

            await ann.setQuestion(new Question({ text: `Did it bother you that Joe kissed me?`, key: `todBotheredByJoeKiss` })
                .option({ title: `Yes`, key: true })
                .option({ title: `No`, key: false }));


            if (Question.globalAnswers.todBotheredByJoeKiss) {
                mc.talk(`Yes it does...`);
            } else {
                mc.talk(`No it didn't.`);
                ImageClass.setImage(images.v2_5.TODAnnAlone3);
                ann.talk(`Oh really? Ok.`);
                mc.talk(`It was just a kiss.`);
            }

            ann.talk(`I have no idea why he would do that.`);
            ann.talk(`Especially with Vanessa here.`);
            mc.think(`Because I told him I don't mind.`);
            mc.talk(`Yeah, me neither...`);
        } else {
            if (Question.globalAnswers.todMcAnnSecondTimeKiss === "joey") {
                return jump(TODAnnAlone1_Continue_Question_WhyKissJoe, "TODAnnAlone1_Continue_Question_WhyKissJoe");

            }

        }
        if (ann.properties.kissedDuringTOD.includes("vanessa")) {
            return jump(TODAnnAlone1_Continue_Question_WhyKissVanessa, "TODAnnAlone1_Continue_Question_WhyKissVanessa");

        } else if (ann.properties.kissedDuringTOD.includes("mc")) {
            ann.talk(`I'm really glad you told me to kiss you and not someone else.`);
            ann.talk(`Well...`);
            ann.talk(`Since things are moving really really fast.`);
            ann.talk(`I was wondering...`);

            return jump(TODAnnAlone1_Continue_Question_ThinkOfVanessa, "TODAnnAlone1_Continue_Question_ThinkOfVanessa");
        }

    }

    return jump(TODAnnAlone1_Continue_Back, "TODAnnAlone1_Continue_Back");

};

export const TODAnnAlone1_Continue_Question_WhyKissJoe = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone3);
    await ann.setQuestion(new Question({ text: `Why did you tell me to kiss Joe?`, key: `todAnnAsksWhyKissJoe` })
        .option({ title: `I like seeing you with other people`, key: `IlikeSeeingYouWithOthers` })
        .option({ title: `I don't know`, key: `dunno` }));


    if (Question.globalAnswers.todAnnAsksWhyKissJoe === "IlikeSeeingYouWithOthers") {
        mc.talk(`I like seeing you with other people.`);
        ImageClass.setImage(images.v2_5.TODAnnAlone3_1);
        ann.talk(`Wow. Really?`);
        ann.talk(`I thought you would like to have me all to yourself...`);
        mc.talk(`You can be mine, but I don't care when you are with other people.`);
        ann.talk(`That's a first for me...`);
        mc.talk(`Is it weird for you?`);
        ann.talk(`Mmm... It's different.`);
        mc.talk(`Oh, ok.`);
    } else {
        mc.talk(`I don't know, it felt like the right thing to do.`);
        ann.talk(`Oh... I would have figured you would want to dare me to kiss you.`);
        mc.talk(`Maybe next time.`);
        ann.talk(`Ok...`);
    }
    return jump(TODAnnAlone1_Continue_Back, "TODAnnAlone1_Continue_Back");
};

export const TODAnnAlone1_Continue_Question_WhyKissVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone3);

    await ann.setQuestion(new Question({ text: `Why did you tell me to kiss Vanessa?`, key: `todAnnAsksWhyKissVanessa` })
        .option({ title: `I like seeing girls kiss`, key: `IlikeSeeingYouWithGirls` })
        .option({ title: `I don't know`, key: `dunno` }));


    if (Question.globalAnswers.todAnnAsksWhyKissVanessa === "IlikeSeeingYouWithGirls") {
        mc.talk(`I like seeing girls kiss.`);
        ImageClass.setImage(images.v2_5.TODAnnAlone3);
        ann.talk(`Guys...`);
        mc.talk(`What's wrong with that?`);
        ann.talk(`Instead of daring me to kiss you, you wanted me to kiss Vanessa?`);
        ann.talk(`I'll never get it.`);
        mc.talk(`It's a guy thing.`);
        ann.talk(`Yeah. I figured.`);
    } else {
        mc.talk(`I don't know it felt like the right thing to do.`);
        ann.talk(`Oh... I figured you would want to dare me to kiss you.`);
        mc.talk(`Maybe next time.`);
        ann.talk(`Ok...`);
    }

    return jump(TODAnnAlone1_Continue_Back, "TODAnnAlone1_Continue_Back");
};

export const TODAnnAlone1_Continue_Question_ThinkOfVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnAlone3);
    await ann.setQuestion(new Question({ text: `What do you think of Vanessa?`, key: `todWhatDoYouThinkOnVanessa` })
        .option({ title: `She is a slut`, key: `slut` })
        .option({ title: `She is really nice`, key: `nice` }));


    if (Question.globalAnswers.todWhatDoYouThinkOnVanessa === "slut") {
        mc.talk(`She is a slut.`);
        ImageClass.setImage(images.v2_5.TODAnnAlone3_1);
        ann.talk(`Oh wow.`);
        mc.talk(`Was that the wrong answer?`);
        ann.talk(`It can't be wrong, it's your answer.`);
        ann.talk(`I was just surprised by the honesty.`);
        ann.talk(`I know what she's like, but it's funny to hear that out loud.`);
    } else {
        mc.talk(`She is really nice.`);
        ann.talk(`Yeah... She is my best friend.`);
        ann.talk(`Even though she has that mean side of her.`);
        ann.talk(`I know she doesn't mean to insult.\nMost of the time...`);
    }
    mc.talk(`Why did you ask that?`);
    ann.talk(`Because of your dare.`);
    mc.talk(`I was just fooling around with her.`);
    mc.talk(`I think she would have done it even if I hadn't dared her to do that.`);
    ann.talk(`Yeah, that sounds like her.`);

    return jump(TODAnnAlone1_Continue_Back, "TODAnnAlone1_Continue_Back");
};

export const TODAnnAlone1_Continue_Back = async (): Promise<any> => {

    if (mc.properties.annStatus === "gf") {
        if (Question.globalAnswers.v2_5WhoWouldYouFuck === "vanessa") {
            ImageClass.setImage(images.v2_5.TODAnnAlone3);
            ann.talk(`What about Vanessa?`);
            mc.talk(`What about her?`);
            ann.talk(`When Joe asked you who you rather... Sleep with.`);
            ann.talk(`You said Vanessa.`);
            mc.talk(`Yeah...`);
            ann.talk(`Why?`);
            mc.talk(`It seemed like the right thing to say.`);
            mc.talk(`She must have a lot of experience in bed.`);
            ann.talk(`She does...`);
            mc.talk(`So that's why.`);
        } else {
            ImageClass.setImage(images.v2_5.TODAnnAlone3);
            ann.talk(`I'm really glad you chose me when Joe asked you that question...`);
            ann.talk(`As Vanessa said, people usually pick her...`);
            ann.talk(`Or so she keeps telling me...\nIt's the first time I played this game with her.`);
            mc.talk(`I really like you, of course I'd choose you.`);
            ann.talk(`Thank you hehe.`);
        }
    }


    ImageClass.setImage(images.v2_5.TODSelfJoe1, { transition: true });

    joe.talk(`We are back!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtAnn);
    vanessa.talk(`I hope you guys enjoyed some alone quality time.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    joe.talk(`Let's continue.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtJoe);
    ann.talk(`Wait.`);
    return jump(TODBeforeEnd, "TODBeforeEnd");
};


export const TODVanessaAlone1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODVanessaAlone1);
    vanessa.talk(`Nice move. Trying to get me jealous?`);
    mc.talk(`You tell me.`);
    vanessa.talk(`I'm not.`);
    mc.talk(`How come?`);
    if (mc.properties.annStatus === "natural") {

        vanessa.talk(`You don't know Ann.`);
    } else {

        vanessa.talk(`You should know her by now.`);
    }

    vanessa.talk(`She won't do anything with him even if he begs.`);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        vanessa.talk(`I forgot to mention it at the bar, but you are way cooler than how Joe described you.`);

    } else {

        vanessa.talk(`By the way, you are way cooler than how Joe described you.`);
    }

    vanessa.talk(`You're really easy going.`);
    mc.talk(`How did you expect me to be?`);
    vanessa.talk(`Like Ann... Haha.`);
    if (mc.properties.annStatus === "hate") {

        mc.talk(`I can understand why you would think that.`);
    } else {
        mc.talk(`She is cool, don't say that.`);
        if (mc.properties.annStatus === "natural" && Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
            vanessa.talk(`How can you be so sure, isn't it the first time you two meet?`);
            mc.talk(`It is, but I can tell she is a nice person.`);
            vanessa.talk(`Yeah... She really is.`);
        }
        vanessa.talk(`Looks like someone is falling for Ann!`);
        if (mc.properties.annStatus === "natural") {
            mc.talk(`I could have, but you didn't give me the chance to know her.`);
            mc.talk(`Besides... She likes your boyfriend.`);
            vanessa.talk(`Nonsense! She just said that because she doesn't know anyone else.`);
            mc.talk(`I don't know, I believe it was genuine.`);
            vanessa.talk(`Don't worry, you'll have plenty of time to talk.`);
            vanessa.talk(`It's not like she is going out on dates every day, haha.`);
        } else {
            mc.talk(`She is really cool.\nYou should give her some slack.`);
            vanessa.talk(`I am!`);
            mc.talk(`Not really. You tease her a lot.`);
            vanessa.talk(`That's just how I am...`);
            ImageClass.setImage(images.v2_5.TODVanessaAlone2);
            vanessa.talk(`Did she say something to you about me?`);
            mc.talk(`No, that's just me saying.`);
            vanessa.talk(`I'll try to be more gentle with her.`);
            mc.talk(`Great.`);
        }
    }

    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        mc.think(`I still need to decide what I'm going to do with that picture Chris showed me.`);
        mc.think(`Joey and Ann should come back any minute now, so it's not a good time to confront her.`);
    }


    ImageClass.setImage(images.v2_5.TODSelfJoe1, { transition: true });
    joe.talk(`Back!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtJoe);

    vanessa.talk(`That was fast.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`Ann, you are really good!`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODJoeLookingAtVan);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ann.talk(`Shut up!`);
    joe.talk(`Haha, we've just caught up on some stuff.`);
    joe.talk(`Ready?`);
    return jump(TODBeforeEnd, "TODBeforeEnd");
};
export const TODBeforeEnd = async (): Promise<any> => {
    ImageClass.setImage({
        ...images.v2_5.TODSelfJoe1, partialsToDisplay:
            [images.v2_5.TOD8.partials.TODAnnLookingAtVanessa,
            images.v2_5.TOD8.partials.TODJoeLookingAtAnn,
            images.v2_5.TOD8.partials.TODVanessaLookingAtAnn
            ]
    });
    if (mc.properties.annStatus === "hate") {
        ann.talk(`Guys, I'm done with this game.`);

        vanessa.talk(`Done? Do you want to do something else?`);
        ann.talk(`No, I'm going home.`);
        vanessa.talk(`Don't be a buzzkill!`);
        vanessa.talk(`The fun's only just starting.`);
        ann.talk(`I'm sorry but I'm really tired.`);
        vanessa.talk(`Do you need us to walk you home?`);
        ann.talk(`No, I can manage.`);
        vanessa.talk(`Bye, Ann.`);
        joe.talk(`Cya.`);
        mc.talk(`Bye.`);

    } else {
        ann.talk(`Guys, I'm done with this game.`);

        vanessa.talk(`Done? Do you want to do something else?`);
        ann.talk(`You can continue, I brought a book, I'll do some reading.`);
        ann.talk(`Just call me when you are ready to head home.`);
        joe.talk(`We plan on staying the night.`);
        ann.talk(`So maybe I'll come back after a few pages.`);
        joe.talk(`Alright.\nEnjoy your book.`);
        ann.talk(`Thank you.`);
    }

    return jump(TODEnd, "TODEnd");
};


export const TODEnd = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODJoeAndVanessa1, { transition: true });

    mc.talk(`So, now what?`);
    vanessa.talk(`I have no idea. Joe?`);
    joe.talk(`Truth or dare with only three people is boring. I mean, I'll do all Vanessa's dare and she will do mine. So that's not fun anymore.`);
    vanessa.talk(`Ann stayed longer than I thought she would.`);
    vanessa.talk(`Speaking of Ann.`);
    vanessa.talk(`${mc.name}, when are you going to fuck her?`);
    if (mc.properties.annStatus === "hate") {
        mc.talk(`I'm not really into her.`);
        if (Question.globalAnswers.todMcAnnSecondTimeKiss === "mc") {
            joe.talk(`You did ask her to kiss you.`);
            mc.talk(`Yeah, I was just messing around.`);
        }
        if (Question.globalAnswers.v2_5WhoWouldYouFuck === "ann") {
            vanessa.talk(`You said you want to fuck her just now.`);
            mc.talk(`Yeah, I do.`);
            vanessa.talk(`So do it already.`);
        }
        if (Question.globalAnswers.todGoRoomWith === "vanessa") {
            joe.talk(`What happened when you stayed alone in the living room?`);
            mc.talk(`Nothing special.`);
            if (Question.globalAnswers.todAnnLivingRoomSeenChrisPic != undefined) {
                mc.talk(`Oh yeah, she did get a text from Chris.`);
                vanessa.talk(`What did he say??`);
                mc.talk(`Something about her having a pretty smile.`);
                mc.talk(`He also sent her a picture.`);
                vanessa.talk(`Go on!`);
                if (!Question.globalAnswers.todAnnLivingRoomSeenChrisPic) {
                    mc.talk(`I didn't want to see the picture.`);
                    vanessa.talk(`Why not?`);
                    mc.talk(`It's not interesting.`);
                    vanessa.talk(`Fine, I'll ask her to show me that tomorrow. Haha.`);
                }
            }

        }
        mc.talk(`She is still angry at me.\nThis game was way too soon, you should have given her more time.`);
        joe.talk(`I planned it for some time, I didn't know you are going to have a fight.`);
        mc.talk(`What did you plan? There wasn't anything special. Just us playing.`);
        joe.talk(`I planned on doing it.`);
        mc.talk(`Ok.`);
        vanessa.talk(`I'm getting pretty tired myself...`);
        joe.talk(`Yeah me too.`);
        mc.talk(`Are you staying the night?`);
        joe.talk(`Yeah.`);
        mc.talk(`Fine, I'll give you some space.\nI'll be in my room if you need anything.`);
        return jump(TODAnnRoom2, "TODAnnRoom2");
    } else if (mc.properties.annStatus === "gf") {
        mc.talk(`I am just trying to stick to her pace, I know she likes to take things slow.`);
        vanessa.talk(`Well, on a serious note, I am happy for both of you.`);
        mc.talk(`Thanks Vanessa.`);
    } else {
        mc.talk(`I don't really know her.`);
        vanessa.talk(`What's stopping you?`);
        mc.think(`You did, when I was supposed to meet with her at the bar.`);
        mc.talk(`You know. Other plans.`);
        vanessa.talk(`Yeah, I totally get it.`);
    }


    return jump(TODAnnSleep, "TODAnnSleep");


};


export const TODAnnLeft = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Room2_2, { transition: true });
    if (!Game.seenScenarios.includes("TODAnnLeft")) {
        mc.talk(`It's been a long day. Time to get some sleep.`);

        return jump(V2Screen, "V2Screen");
    }
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
    ImageClass.setImage(images.v1.Room2, { transition: true });
    mc.talk(`It's morning.`);
    return jump(TODEndingRoom, "TODEndingRoom");
};
export const TODAnnSleep = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODJoeAndVanessa1);
    vanessa.talk(`Well, I ain't gonna lie, but all that kissing got me horny.`);
    vanessa.talk(`I think we should cancel tonight.`);
    vanessa.talk(`Joe. Let's go home. I need some of your special treatment. Haha.`);


    vanessa.talk(`${mc.name}, is that fine by you?`);
    mc.talk(`Sure.`);
    vanessa.talk(`I'm going to get Ann and we'll leave.`);

    ImageClass.setImage(images.v2_5.TODJoeAlone, { duration: 0.6 });
    joe.talk(`Sorry again for leaving you here alone bro.`);
    joe.talk(`Just say the word, and I'll stay.`);
    mc.talk(`It's ok, really.`);
    joe.talk(`Vanessa is really something, isn't she?`);
    mc.talk(`Yeah... She is something.`);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        joe.talk(`By the way, what did you want to talk about in your room earlier?`);
        mc.talk(`So, remember when I met with Ann yesterday?`);
        joe.talk(`Yes.`);
        mc.talk(`So...`);
    }
    ImageClass.setImage(images.v2_5.TODJoeAndVanessa2, { transition: true });
    vanessa.talk(`I changed my mind, let's stay.`);
    joe.talk(`Why? What happened?`);
    ImageClass.setImage(images.v2_5.TODJoeAndVanessa1);
    vanessa.talk(`${mc.name} I have a dare for you.`);
    mc.talk(`But we finished playing already.`);
    vanessa.talk(`Don't be a pussy! Are you up to it?`);
    mc.talk(`What is it?`);
    vanessa.talk(`Funny thing, but Ann fell asleep in your room.`);
    vanessa.talk(`So I dare you to go there and sleep next to her naked.`);
    mc.talk(`Isn't that a bit extreme?`);
    if (mc.properties.annStatus === "hate") {

        mc.talk(`I barely know her...`);
    }
    vanessa.talk(`It's your house, isn't it?`);
    mc.talk(`It is but still... I'll have to think about it.`);
    vanessa.talk(`Ok, but do it before she wakes up.`);
    joe.talk(`I thought we were going home.`);
    vanessa.talk(`Babe, there are more important things.`);
    mc.talk(`Are you going to stay the night after all?`);
    joe.talk(`N...`);
    vanessa.talk(`YES!`);
    vanessa.talk(`Just go already!`);
    return jump(TODAnnRoom, "TODAnnRoom");
};
export const TODAnnRoom = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnSleepingFar, { transition: true });
    mc.think(`Did she plan on sleeping here? She covered herself up.\nNo way she just fell asleep.`);
    mc.think(`On the other hand, the light is still on, so I have no idea.`);
    return jump(TODAnnRoom2, "TODAnnRoom2");

};
export const TODAnnRoom2 = async (): Promise<any> => {
    if (mc.properties.annStatus !== "hate") {

        ImageClass.setImage(images.v2_5.TODAnnSleepingFar, { transition: true });
    } else {
        ImageClass.setImage(images.v1.Room2, { transition: true });
        mc.think(`Time to get some sleep.`);
        empty.think(`*Squeak squeak*`);
    }

    mc.think(`I hear moaning from the living room.`);
    await mc.setQuestion(new Question({ text: `I bet Joey and Vanessa are fucking.`, options: { think: true }, key: `todWatchedJoeVanessaFucking` })
        .option({ title: `Go watch`, key: true })
        .option({ title: `Just go to sleep`, key: false }));


    if (Question.globalAnswers.todWatchedJoeVanessaFucking) {
        // <action type="start-recording" rid="van_Joe" title="Vanessa and Joe are having fun"/>
        return jump(TODWatchingVanessaJoe, "TODWatchingVanessaJoe");
    } else {
        if (mc.properties.annStatus === "hate") {

            return jump(TODAnnLeft, "TODAnnLeft");
        } else {

            return jump(TODEnteredRoom, "TODEnteredRoom");
        }

    }
};
export const TODWatchingVanessaJoe = async (): Promise<any> => {
    ImageClass.setAnimation(images.v2_5.Anim_VanessaJoeLivingRoomDoggy);

    mc.think(`I expected no less.`);
    mc.think(`They didn't even wait for me to fall asleep.`);
    mc.think(`He is really pounding her.`);
    mc.think(`She is moaning, but not too loud.`);
    ImageClass.setImage(images.v2_5.TODJoeVanessaFuck2, { transition: true, duration: 1 });
    mc.think(`Holy shit, he came on her face.`);
    mc.think(`That was fast...`);
    ImageClass.setAnimation(images.v2_5.pre_VanessaJoeLivingRoomCumTease);
    // <action type="image" video="true" nb="true" wi="false" preload="Game/V2.5/pre_VanessaJoeLivingRoomCumTease" loop="true">Game/V2.5/Anim_VanessaJoeLivingRoomCumTease</action>
    mc.think(`She really likes the feeling of cum on her face... She keeps teasing him even after he came.`);
    ImageClass.setImage(images.v2_5.TODJoeVanessaFuck3, { duration: 1 });
    mc.think(`And she keeps sucking after he came on her. Wow.`);
    mc.think(`Joey is pretty demanding, but she is not resisting.`);
    mc.think(`Now I can understand why he likes her so much.`);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {

        mc.think(`I bet Chris got the same treatment.`);
    }
    mc.think(`I should go before they see me.`);

    await endReplay(replayScenesList.v25VanessaJoeLivingRoom);
    // await mc.set((properties) => {
    //     properties.JennyProfilePic1 = properties.JennyProfilePic1;
    // });

    if (mc.properties.annStatus === "hate") {

        return jump(TODAnnLeft, "TODAnnLeft");
    } else {
        ImageClass.setImage(images.v2_5.TODAnnSleepingFar, { transition: true });
        mc.talk(`Time to enter the room.`);
        return jump(TODEnteredRoom, "TODEnteredRoom");
    }
};
export const TODEnteredRoom = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.TODAnnSleepingClose);
    mc.think(`She is sleeping heavily, she didn't hear me coming in.`);
    await mc.setQuestion(new Question({ text: `Vanessa dared me to enter the bed naked.`, options: { think: true }, key: `afterTODEnteredNaked` })
        .option({ title: `Get in naked`, key: true })
        .option({ title: `Get in dressed`, key: false }));


    if (Question.globalAnswers.afterTODEnteredNaked) {
        await ann.set((properties) => {
            properties.corruption++;
        });
        mc.think(`I know it's a bad idea, but a dare is a dare.`);
        mc.think(`Here goes nothing.`);
    } else {
        mc.think(`That's so stupid, I'm not gonna do that to her.`);
    }

    return jump(V2Screen, "V2Screen");

};

export const TODBedNaked = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 2 });
    ImageClass.setImage(images.v2_5.MCNaked, { shake: true });
    ann.talk(`AHH!!`);
    ann.talk(`What are you doing??`);
    ImageClass.setImage(images.v2_5.TODAnnWokeUp1);
    mc.talk(`Is it morning already?`);
    ann.talk(`Why are you naked???`);
    mc.talk(`Wait, I can explain!`);
    ImageClass.setImage(images.v1.RoomAlone_2);
    mc.think(`She left.`);
    mc.think(`I should get dressed and see if I can catch up to her.`);
    ImageClass.setImage(images.v2_5.TODMorningJoeVan1, { transition: true });
    joe.talk(`I heard Ann screaming.\nWhat happened?`);
    mc.talk(`Where is she?`);
    joe.talk(`She went out running.`);
    joe.talk(`What did you do?`);
    mc.talk(`I did my dare.`);
    ImageClass.setImage(images.v2_5.TODMorningJoeVan2);
    vanessa.talk(`OH MY GOD, you really did it! HAHA!`);
    vanessa.talk(`I didn't think you would actually do it!`);
    joe.talk(`Oh my God bro, haha.`);
    mc.talk(`Well, I did, now what?`);
    vanessa.talk(`I'll try to talk to her.`);
    mc.talk(`Why did you tell me to do it if you knew she was going to freak out?`);
    vanessa.talk(`I don't know... Joe told me you are pretty smart.`);
    vanessa.talk(`Oh my God! That's so funny!`);
    mc.talk(`Wait, don't call her.`);
    mc.talk(`I'll try calling her first.`);

    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn, { transition: true });
    empty.think(`Calling Ann...`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    mc.think(`...`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`No answer.`);
    return jump(TODEndingRoom, "TODEndingRoom");

};
export const TODBedNotNaked = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 2 });
    ImageClass.setImage(images.v2_5.MCNotNaked);
    ann.talk(`${mc.name}?`);
    ann.talk(`${mc.name}...`);
    if (mc.properties.annStatus === "natural") {
        ImageClass.setImage(images.v2_5.TODAnnWokeUp3);
        ann.talk(`I'm so sorry, I fell asleep in your bed.`);
        ann.talk(`Why didn't you wake me up?`);
        mc.talk(`I didn't want to disturb you.`);
        ann.talk(`I know... I'm a heavy sleeper.`);
        ann.talk(`My parents must be worried sick, they have no idea where I am at. I should get home fast.`);
    } else {
        ImageClass.setImage(images.v2_5.TODAnnWokeUp2);
        ann.talk(`I must have fallen asleep.`);
        ann.talk(`Why didn't you wake me up?`);
        mc.talk(`You looked so cute sleeping.\nI didn't want to disturb you.`);
        ann.talk(`Oh, hehe.`);
        ann.talk(`Did Joe and Vanessa leave?`);
        mc.talk(`I think they are still in the living room.`);
        ann.talk(`Oh...`);
        ann.talk(`I really need to get going, I didn't tell my parents I'd be staying the night.`);
        ann.talk(`And I don't want to deal with Vanessa right now, she will start teasing me for sleeping in the same room with you.`);
        mc.talk(`You can leave through the back door, she won't see you.`);
        ann.talk(`Great, thanks!`);
        ann.talk(`I had a good time, thanks for inviting me.`);
    }
    ImageClass.setImage(images.v1.RoomAlone_2);
    mc.think(`She left.`);
    return jump(TODEndingRoom, "TODEndingRoom");
};

export const TODEndingRoom = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomAlone_2);

    if (mc.properties.annStatus === "hate") {
        mc.think(`Today is going to be a long day.`);
        mc.think(`I should figure out what I want to achieve from my relationship with Ann.`);
        mc.think(`I can't keep doing what I'm doing right now.`);
    } else {
        if (Question.globalAnswers.afterTODEnteredNaked) {
            mc.think(`I'll give her some time.`);
            mc.think(`I'll wait for a bit before going to meet Vanessa and Joey in the living room.`);
        }
    }
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        mc.think(`I should decide if I want to confront Vanessa about Chris.`);
        mc.think(`Or I can just tell Joey what I know.`);
    }
    if (mc.properties.vanessaRelationship > 1) {
        mc.think(`I need to figure out what I'm gonna do with Vanessa. I really like her, but she is Joey's girlfriend.`);

    }

    return jump(AfterTOD, "AfterTOD");
};



export const V2Screen = async (): Promise<any> => {

    if (Question.globalAnswers.afterTODEnteredNaked) {
        return jump(TODBedNaked, "TODBedNaked");
    } else if (Question.globalAnswers.afterTODEnteredNaked === false) {

        return jump(TODBedNotNaked, "TODBedNotNaked");
    }
    return jump(TODAnnLeft, "TODAnnLeft");

};
